import React from 'react'
// import myImage from '../assets/images/logo512.png'
import '../CSS/style.css'
import '../CSS/responsive.css'

export default function TeamTemplate(props) {
  return (
    <>
        <div className=" teams text-center borderLeft">
            <div className="profile"><img className='profileimg' src={props.profile} alt="Profile" /></div>
            <div className="teamdescription flex fd-col">

            <div className="name p-heading">{props.name}</div>
            <div className="designation">{props.designation}</div>
            <div className="aboutPerson ">{props.aboutPerson}</div>
            </div>
        </div>
    </>
  )
}
